import { motion } from 'framer-motion'
import useLocalStorage from '@/hooks/use-local-storage'
// @ts-ignore
import { LoginResponse } from '@/@types/auth'

interface WelcomeMessageProps {
  className?: string
}

export function WelcomeMessage({ className }: WelcomeMessageProps) {
  const [userInfo] = useLocalStorage<LoginResponse | undefined>({
    key: 'vbAuth',
    defaultValue: undefined,
  })
  
  const data = userInfo?.data ?? userInfo
  const userName = data?.user?.name || 'User'
  
  // Extract first name from full name
  const firstName = userName.split(' ')[0]

  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
      className={`flex items-center ${className || ''}`}
    >
      <div className="flex flex-col">
        <motion.h1 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.1, duration: 0.3 }}
          className="text-xl font-bold tracking-tight text-foreground"
        >
          Welcome to Staffluent
        </motion.h1>
        <motion.p 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.3 }}
          className="text-sm text-muted-foreground"
        >
          {firstName}
        </motion.p>
      </div>
    </motion.div>
  )
}